var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"7fd5d64de39cf79aa338e0ee1a7656e1006215d1"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["transfez-business@transfez"]={id:"7fd5d64de39cf79aa338e0ee1a7656e1006215d1"};
      